import { doSearchStoreAction, loadGridColumnSettingStoreAction, loadSavedFilterStoreAction } from '../../../Generic/SearchPage/actions/searchPageActions';
import { ObjectTypes } from '../../../../utils/constants';
import { cylinderSearchActions as searchPageSliceActions } from '../slices/cylinderSearchSlice';
import cylinderApi from '../../../../services/api/CylinderApi';
import { getEndDateWithTime, getStartDateWithTime } from '../../../../utils/constants/datetime';
import { getClientIdsScreenAccessByState } from '../../../../utils/screenPermission';
import { getUserTimezone } from '../../../../hooks/useAuth';

const getStateSliceForSearchPage = (state) => state.cylinderSearch;
export const loadGridColumnSettingStoreActionHandler = () => async (dispatch, getState) => loadGridColumnSettingStoreAction({
  dispatch,
  getState,
  searchPageSliceActions,
  getStateSliceForSearchPage,
  objectTypeGridColumns: ObjectTypes.CylinderSearchGrid
});

export const loadSavedFilterStoreActionHandler = () => async (dispatch, getState) => loadSavedFilterStoreAction({ dispatch, getState, searchPageSliceActions, getStateSliceForSearchPage, objectTypeForSaveUserFilter: ObjectTypes.CylinderSearchUserFilter });

export const doSearchStoreActionHandler = () => async (dispatch, getState) => {
  const state = getState();
  const clientIDs = getClientIdsScreenAccessByState(state, 'Cylinders');
  const timezone = getUserTimezone(state);
  const searchParamBuilder = (filter) => ({
    clientIDs: filter?.clientIDs?.length ? filter?.clientIDs.map((client) => client.ClientID || client) : clientIDs,
    cylinderType: filter?.CylinderType?.id ?? null,
    cylinderStatus: filter?.Status?.id ?? null,
    orderNumber: filter?.OrderNumber ?? '',
    rentalAgreementNumber: filter?.RentalAgreementNumber ?? '',
    cylinderSubStatus: filter?.SubStatus?.id ?? null,
    requestor: filter?.Requestor?.id ?? '',
    reportAddressIDs: filter?.reportAddressIDs?.map((address) => address.id) ?? [],
    daysOut: filter?.DaysOut ?? null,
    shippingDateFrom: filter?.ShippedDateFrom ? getStartDateWithTime(filter?.ShippedDateFrom, timezone).toISOString() : null,
    shippingDateTo: filter?.ShippedDateTo ? getEndDateWithTime(filter?.ShippedDateTo, timezone).toISOString() : null,
  });

  await doSearchStoreAction({
    dispatch,
    getState,
    searchPageSliceActions,
    getStateSliceForSearchPage,
    searchParamBuilder,
    searchWithPaginationApi: cylinderApi.searchCylinder,
    postResultsProcessHandler: null
  });
};
